module.exports = __webpack_public_path__ + "img/jd.d0762c7d.png";